import axios from 'axios';
import {
  API_CLASSROOMS_PICTURE,
  API_BACKOFFICE_ASSETS,
  API_BACKOFFICE_ASSETS_UPLOAD_AVAILABILITY,
  API_BACKOFFICE_ASSETS_UPLOAD_PRESIGN,
  API_BACKOFFICE_ASSETS_UPLOAD
} from '../api/apiConst';
import { manageObjectResponse } from '../api/apiResponse';
import { PARAMS } from '../../const';
import { getLogger } from '../logger';

const debug = getLogger('services:assets:assetsService');

export const uploadAsset = async (asset, assetMetadata, options = {}) => {
  const {
    handleUploadContentStatus = () => {},
    createAssetAfterUpload = true,
    defaultUuid,
    lastAsset = true
  } = options;

  if (asset) {
    const { customerId, assetType, classroomId } = assetMetadata;
    let { fileName } = assetMetadata;
    try {
      await axios.get(API_BACKOFFICE_ASSETS_UPLOAD_AVAILABILITY.replace(PARAMS.CUSTOMER, customerId));

      let url = `${API_BACKOFFICE_ASSETS_UPLOAD_PRESIGN.replace(PARAMS.CUSTOMER, customerId)}?fileName=${encodeURI(
        fileName
      )}&assetType=${assetType}`;
      if (classroomId) {
        url = `${url}&classroomId=${classroomId}`;
      }
      if (defaultUuid) {
        url = `${url}&defaultUuid=${defaultUuid}`;
      }
      const preSignedRequest = await axios.get(url);

      const uploadData = new FormData();
      const file = typeof asset === 'string' ? dataURLtoFile(asset, fileName) : asset;
      uploadData.append('file', file, fileName || file.name);

      const isBodyExtended = Object.entries(preSignedRequest.data.body).length > 0;

      if (isBodyExtended) {
        Object.entries(preSignedRequest.data.body).map(([key, value]) => uploadData.append(key, value));
      }

      let CancelToken = axios.CancelToken;
      let cancel;

      await axios({
        url: preSignedRequest.data.url,
        method: preSignedRequest.data.method,
        headers: preSignedRequest.data.headers,
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
        onUploadProgress: progressEvent => {
          try {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            const status = {
              percentCompleted,
              isUploading: true,
              cancelUpload: cancel
            };
            handleUploadContentStatus(status);
          } catch (err) {
            console.error(err);
          }
        },
        data: isBodyExtended ? uploadData : file,
        preventInterceptors: true
      });

      if (createAssetAfterUpload) {
        return createAsset(
          customerId,
          classroomId,
          defaultUuid || preSignedRequest.data.uuid,
          fileName,
          assetType,
          file.type,
          lastAsset
        );
      }
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  debug.error('[uploadAsset] asset is empty');
};

export let getAsset = (uuid, customerId) => {
  if (uuid) {
    let url = API_BACKOFFICE_ASSETS.replace(PARAMS.ASSET, uuid).replace(PARAMS.CUSTOMER, customerId);
    return manageObjectResponse(axios.get(url));
  }
  debug.error('[getAsset] asset UUID is empty');
};

export const createAsset = async (
  customerId,
  classroomId,
  uuid,
  fileName,
  assetType,
  mimeType,
  lastAsset = true,
  wrapper
) => {
  const payload = { uuid, fileName, assetType, mimeType, lastAsset, wrapper };
  if (classroomId) {
    payload.classroomId = classroomId;
  }
  const createAssetResponse = await axios.post(
    API_BACKOFFICE_ASSETS_UPLOAD.replace(PARAMS.CUSTOMER, customerId),
    payload
  );
  return createAssetResponse.data;
};

export let getClassroomImageUrl = (classroomId, params) => {
  if (classroomId) {
    return `${API_CLASSROOMS_PICTURE.replace(PARAMS.CLASSROOM, classroomId)}?${params}`;
  }
  debug.error('[getClassroomImage] classroom image error');
};

export let getClassroomImage = (classroomImages, selectedClassroom, classroomAsset, classroomPicture) => {
  if (classroomAsset) {
    const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
    if (uuidRegex.test(classroomAsset)) {
      return getClassroomImageUrl(selectedClassroom.id, classroomPicture || classroomAsset);
    }
    return classroomAsset;
  } else if (classroomPicture) {
    return classroomImages[classroomPicture];
  }
  return '';
};

// -------------------------------------------------------------------

export let bytesToMegas = bytes => {
  return bytes / 1048576;
};

// -------------------------------------------------------------------

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
